// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"64596747","2433":"64596747","3032":"64596747"}[chunkId] + ".chunk.css";
};